import type { PromptFieldOptions } from '@cli-types/next-adapter/commands.js'
import { CREATE_FIELD_PROMPT_OPTIONS } from '@cli-constants/prompt-copy.js'
import { getFieldNames } from '../schema-prompts/get-field-names.js'

export function createFieldPromptOptions(fields: Array<{ name?: string }>): PromptFieldOptions {
  return {
    ...CREATE_FIELD_PROMPT_OPTIONS,
    existingNames: getFieldNames(fields)
  }
}
